import { Checkbox, Modal } from 'antd';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import Enums from 'utils/EnumsManager';
import { resetOnDrop, setActions } from '../../flow/actions';

const CheckboxGroup = Checkbox.Group;
const { REPORTS, DROPZONES } = Enums;
const { AGGREGATES } = DROPZONES;
const { AGGREGATES_ZONE_TAG_ACTIONS } = REPORTS;

const defaultProps = {};
const propTypes = {
  setActions: PropTypes.func.isRequired,
  resetOnDrop: PropTypes.func.isRequired
};

class AggregateModal extends Component {
  state = {
    checkedValues: []
  };

  handleCheckboxChange = checkedValues => this.setState({ checkedValues });
  handleCancelClick = () => this.props.resetOnDrop();
  handleOkClick = () => {
    const columns = this.props.data.filter(col => col.onDrop);
    if (columns.length === 1) {
      this.props.setActions(columns[0].id, this.state.checkedValues);
      this.props.resetOnDrop();
      this.setState({ checkedValues: [] });
    } else {
      // Report error
      console.error('Invalid data!');
    }
  };

  render() {
    const i18n = 'page.ReportTableSetup';
    const options = AGGREGATES_ZONE_TAG_ACTIONS.map(action => ({
      label: <FormattedMessage id={`${i18n}.actions.${action}`} />,
      value: action
    }));
    const showModal = this.props.data.some(
      record => record.belongTo === AGGREGATES && record.onDrop
    );

    return (
      <Modal
        visible={showModal}
        title={<FormattedMessage id={`${i18n}.modals.aggregates`} />}
        onOk={this.handleOkClick}
        onCancel={this.handleCancelClick}
        destroyOnClose
      >
        <CheckboxGroup
          options={options}
          onChange={this.handleCheckboxChange}
          className="vertical"
        />
      </Modal>
    );
  }
}

const mapStateToProps = ({ reportSetup }) => ({
  data: reportSetup.sider.availableColumns
});
const mapDispatchToProps = {
  setActions,
  resetOnDrop
};
AggregateModal.defaultProps = defaultProps;
AggregateModal.propTypes = propTypes;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AggregateModal);



// WEBPACK FOOTER //
// ./src/views/ReportTableSetup/components/AggregatesZone/Modal.jsx